/**
 * @generated SignedSource<<ad0190008b97af10c4f09e6ab166f010>>
 * @relayHash b4f729a9efca3d2311f2007f882a964a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fb9fa4f255f32274880c3fc55a657de8206f71fc5007482a2413c16cdad6ffd4

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateUrlFieldInput = {
  id: string;
  operation: JiraUrlFieldOperationInput;
};
export type JiraUrlFieldOperationInput = {
  operation: JiraSingleValueFieldOperations;
  uri?: string | null | undefined;
};
export type url_issueFieldUrl_UrlField_OldMutation$variables = {
  input: JiraUpdateUrlFieldInput;
};
export type url_issueFieldUrl_UrlField_OldMutation$data = {
  readonly jira: {
    readonly updateUrlField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"url_issueFieldUrlInlineEditFull_UrlInlineEditViewOld_fragmentRef">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type url_issueFieldUrl_UrlField_OldMutation$rawResponse = {
  readonly jira: {
    readonly updateUrlField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldConfig: {
          readonly isEditable: boolean | null | undefined;
        } | null | undefined;
        readonly fieldId: string;
        readonly hoverOrFocusState?: {
          readonly isHoveredOrFocused: boolean | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly type: string;
        readonly uri: string | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type url_issueFieldUrl_UrlField_OldMutation = {
  rawResponse: url_issueFieldUrl_UrlField_OldMutation$rawResponse;
  response: url_issueFieldUrl_UrlField_OldMutation$data;
  variables: url_issueFieldUrl_UrlField_OldMutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isSingleLineEventDelegatorEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-event-delegator-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "url_issueFieldUrl_UrlField_OldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUrlFieldPayload",
            "kind": "LinkedField",
            "name": "updateUrlField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraUrlField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewOld_fragmentRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "url_issueFieldUrl_UrlField_OldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUrlFieldPayload",
            "kind": "LinkedField",
            "name": "updateUrlField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraUrlField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "fieldId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "uri"
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "concreteType": "JiraFieldHoverOrFocusState",
                            "kind": "LinkedField",
                            "name": "hoverOrFocusState",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isHoveredOrFocused"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fb9fa4f255f32274880c3fc55a657de8206f71fc5007482a2413c16cdad6ffd4",
    "metadata": {},
    "name": "url_issueFieldUrl_UrlField_OldMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider
    }
  }
};
})();

(node as any).hash = "b908881d73f71a207c8e4cb38dc9a8b3";

export default node;
